var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from 'styled-components';
import { color, variant, margin, textStyle } from 'styled-system';
import Base from './Base';
var StyledText = styled(Base)(function (props) {
    return variant({
        prop: 'variant',
        variants: {
            largeTitle: {
                fontSize: props.theme.fontSizes.largeTitle,
                lineHeight: '56px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.regular,
            },
            title: {
                fontSize: props.theme.fontSizes.title,
                lineHeight: '28px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.semiBold,
            },
            header: {
                fontSize: props.theme.fontSizes.header,
                lineHeight: '32px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.medium,
            },
            subHeader: {
                fontSize: props.theme.fontSizes.subHeader,
                lineHeight: '24px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.medium,
            },
            headlineBody: {
                fontSize: props.theme.fontSizes.headlineBody,
                lineHeight: '26px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.semiBold,
            },
            body1: {
                fontSize: props.theme.fontSizes.body1,
                lineHeight: '22px',
                color: props.theme.color.bodyText,
                fontWeight: props.theme.fontWeights.regular,
            },
            body2: {
                fontSize: props.theme.fontSizes.body2,
                lineHeight: '20px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.regular,
            },
            caption: {
                fontSize: props.theme.fontSizes.caption,
                lineHeight: '20px',
                color: props.theme.color.headlineText,
                fontWeight: props.theme.fontWeights.semiBold,
            },
            smallText: {
                fontSize: props.theme.fontSizes.smallText,
                fontWeight: props.theme.fontWeights.medium,
            },
        },
    });
}, margin, color, textStyle, function (props) { return (__assign({ cursor: props.cursor, textTransform: props.transform }, (props.disabled && { opacity: '50%' }))); });
export default StyledText;
